<template>
    <div class="iframe">
        <div id="navTitle">
            <img class="black" @click="back" src="@/assets/images/template/a_top_return.png"/>
            <span>{{$route.query.title}}</span>
        </div>
        <div id="content">
            <div id="iframeCon">
                <iframe id="iframe" scrolling="auto" frameborder="0"  :src="$route.query.url"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Embed",
        methods: {
            back() {
                this.$router.go(-1);
            },
            iframeHeight(){
                let iframe = document.getElementById("iframe");
                let iframeCon = document.getElementById("iframeCon");
                let iframeConH = document.documentElement.clientHeight;
                let iframeConw=document.documentElement.clientWidth;
                iframeCon.setAttribute( "style","min-height:"+iframeConH+"px");
                iframe.setAttribute("height", iframeConH + 'px');
                iframe.setAttribute("width:",iframeConw+"px");
            }
        },
        mounted() {
            window.scrollTo(0,0);
            this.$bus.$emit('loading', true);
            let mainH = document.getElementById("main");
            mainH.classList.remove('mainFixed');
            this.$nextTick(() =>{
                this.iframeHeight()
            })
        },
        activated(){
            window.scrollTo(0,0);
            this.$bus.$emit('loading', true);
        },
    }
</script>
